export enum Steps {
  READING_ID = 'Opnamekenmerk',
  'INTRODUCTION.EOS' = 'Eindnota',
  'INTRODUCTION.PER' = 'Jaarnota',
  'INTRODUCTION.TME' = 'Tariefwijziging',
  'INTRODUCTION.ER' = 'Energierapport',
  'METER_READINGS.ELECTRICITY' = 'Meterstanden - Stroom',
  'METER_READINGS.GAS' = 'Meterstanden - Gas',
  'METER_READINGS.WARMTH' = 'Meterstanden - Warmte',
  'METER_READINGS.COOLING' = 'Meterstanden - Koeling',
  'METER_READINGS.TAPWATER' = 'Meterstanden - Warm water',
  CONFIRMATION = 'Bevestigen',
  'THANK_YOU.Adhoc' = 'Bedankt',
  'THANK_YOU.TariffMigration' = 'Bedankt - Tariefwissel',
  'THANK_YOU.PeriodicEven' = 'Bedankt - Jaarnota we staan quitte',
  'THANK_YOU.PeriodicNewTermAmount' = 'Bedankt - Jaarnota nieuw termijnbedrag',
  'THANK_YOU.PeriodicPayBack' = 'Bedankt - Jaarnota bijbetalen',
  'THANK_YOU.PeriodicPayBackMore' = 'Bedankt - Jaarnota bijbetalen meer',
  'THANK_YOU.PeriodicPayBackLess' = 'Bedankt - Jaarnota bijbetalen minder',
  'THANK_YOU.PeriodicPayBackTermAmount' = 'Bedankt - Jaarnota Termijnbedrag bijbetalen',
  'THANK_YOU.PeriodicGetBackTermAmount' = 'Bedankt - Jaarnota Termijnbedrag geld terug',
  'THANK_YOU.PeriodicGetBack' = 'Bedankt - Jaarnota geld terug',
  'THANK_YOU.PeriodicDelayed' = 'Bedankt - Jaarnota volgt',
  'THANK_YOU.CloseDown' = 'Bedankt - Opzegging',
  'THANK_YOU.Registration' = 'Bedankt - Aanmelding',
  'THANK_YOU.RelocationNewAddress' = 'Bedankt - Nieuwe woning',
  'THANK_YOU.RelocationOldAddress' = 'Bedankt - Oude woning',
  'THANK_YOU.Unknown' = 'Bedankt - Onbekend',
  'THANK_YOU.EnergyReport' = 'Bedankt - Energierapport',
}
